export default __webpack_public_path__ + "static/media/osteo_frauen.75590c04.jpg";